/* eslint-disable @typescript-eslint/no-explicit-any */
import ScSelectBase from './ScSelectBase';

interface IScMutiSelect {
    selectList: Record<string, any>[];
    idField: string;
    nameField: string;
    selectDefault?: any;
    selectName?: string;
    onChange?: (value: any) => void;
    hintText?: string;
    mode?: 'multiple' | 'tags';
    isDisabled?: boolean;
}

const ScMutiSelect = ({
    selectList,
    idField,
    nameField,
    selectDefault,
    selectName,
    onChange,
    hintText,
    mode,
    isDisabled,
    ...resProps
}: IScMutiSelect) => {
    const options = selectList.map((item) => ({
        value: item[idField],
        label: item[nameField],
    }));

    return (
        <>
            {selectName && (
                <label>
                    <h6 className="panel-title">{selectName}</h6>
                </label>
            )}

            <ScSelectBase
                value={selectDefault}
                className="custom-only-multi-select"
                onChange={onChange}
                placeholder={hintText}
                mode={mode}
                disabled={isDisabled}
                options={options}
                {...resProps}
            />
        </>
    );
};

export default ScMutiSelect;
